module.exports = __webpack_public_path__ + "static/media/volume-down.5c51b325.svg";